// Distinct, mid-saturation hues that read on both light and dark MUI backgrounds.
const PALETTE = ['#4f8df7', '#f7a14f', '#5cc46a', '#e25c7a', '#9b6bf2', '#2fb5b5', '#d9a800', '#8a7f6b'];

/** Same field name → same color across every plugin/day, so a segment type is recognisable at a glance. */
export const colorForField = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
};
